import * as React from 'react';

import type { IconProps } from '../../types';

/**
 * FileShare icon
 *
 * @category Files/Forms/Editing
 */
const FileShare = React.forwardRef<SVGSVGElement, IconProps>(
  ({ 'data-testid': testId, size = 20, className, ...props }, ref) => {
    return (
      <svg
        ref={ref}
        data-testid={testId}
        width={size}
        height={size}
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={className}
        role="img"
        aria-hidden="true"
        {...props}
      >
        <path
          fill="currentColor"
          d="M24.058 11.666c.804 0 .804 1.236 0 1.236H11.1c-.804 0-.804-1.236 0-1.236zm0-3.709c.804 0 .804 1.236 0 1.236H10.975c-.804 0-.804-1.236 0-1.236z"
        />
        <path
          fill="currentColor"
          d="M27.948 22.986V6.589c.011-2.73-2.354-3.819-4.755-3.55-3.233 0-9.312-.034-12.884 0-3.08.258-3.607 2.835-3.396 5.564v7.086c0 .539-.223 1.066-.633 1.429a6.7 6.7 0 0 0-2.26 5.048 6.735 6.735 0 0 0 5.06 6.524c.023.023.034.023.058.023.937.387 1.616.234 3.162.27 4.135-.047 8.667.093 12.708-.047l.117-.024c2.952-.667 2.928-3.385 2.823-5.926M7.03 26.3a5.53 5.53 0 0 1-1.84-4.134c0-1.64.657-3.022 1.723-4.03a5.2 5.2 0 0 1 1.194-.89 5.6 5.6 0 0 1 2.682-.678c3.08 0 5.587 2.506 5.587 5.598a5.586 5.586 0 0 1-5.587 5.587c-.386 0-.76-.035-1.124-.117-.012 0-.023 0-.035-.012a5.5 5.5 0 0 1-2.6-1.324m17.182 1.476c-2.612.21-5.411.07-8.14.082-.645-.023-1.195-.164-.586-.89 4.158-4.076 1.206-11.56-4.697-11.466-1.065-.082-2.67.726-2.67-.855-.059-1.464 0-3.678-.023-4.814.023-1.734-.352-4.708 1.85-5.4 3.373-.667 7.262-.117 10.74-.245 1.792.046 4.217-.434 5.47 1.124.433.562.55 1.241.597 1.933.188 4.24-.023 11.196.047 16.057.105 1.78-.281 4.134-2.378 4.45l-.21.036z"
        />
        <path
          fill="currentColor"
          d="M12.326 26.191c-.98-.04-1.5-.92-1.61-1.8-.3-.32-.97-.69-1.32-.81-.2-.04-.36.04-.58.11-3.05.67-2.62-4.1.3-2.93.43.13 1.25-.51 1.52-.69.27-.39.17-1 .58-1.35.83-1.01 2.67-.48 2.79.86.21 1.32-1.33 2.19-2.42 1.61-.18-.05-.36-.02-.62.13-1.65.81-1.09 1.15.18 1.8.56.21 1.06-.33 1.66-.09 1.76.43 1.5 3.04-.31 3.16zm-.32-1.8c-.02.05-.04.11-.04.17 0 .23.19.42.42.42s.42-.19.42-.42-.19-.42-.42-.42c-.14 0-.26.07-.34.17 0 .01-.01.02-.02.04 0 .01-.02.03-.02.04m-3.7-2.63c-.23 0-.42.19-.42.42s.19.42.42.42c.15 0 .28-.08.36-.2v-.01c.03-.06.05-.13.05-.2s-.02-.14-.05-.2v-.02a.42.42 0 0 0-.36-.2zm3.73-1.73a.42.42 0 1 0-.07-.23c0 .07.02.14.05.19v.04z"
        />
      </svg>
    );
  }
);

FileShare.displayName = 'FileShare';

export { FileShare };
